module.exports = __webpack_public_path__ + "media/fonts/Oricons-770342d7999466e136bbdfa04e42381f.eot";